import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { useEffect } from 'react'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { ILibraryGroup, TCreateLibraryGroupDTO } from '@/pages/Library/libraryGroups.types.ts'
import libraryGroupsApi from '@/pages/Library/libraryGroups.api.ts'
import libraryEvents from '@/pages/Library/events/library.events.ts'
import LibraryGroupDropdown from '@/pages/Library/components/LibraryGroupDropdown'

interface IProps {
  initialParentId?: ILibraryGroup['id']
  open: boolean
  onClose: () => void
}

const CreateLibraryGroupModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [group, setGroup, handleChange] = useStateWithChange<TCreateLibraryGroupDTO>({
    name: '',
    parentId: props.initialParentId ?? null,
  })

  useEffect(() => {
    setGroup({
      name: '',
      parentId: props.initialParentId ?? null,
    })
  }, [props.initialParentId])

  const handleSave = () => {
    wait(libraryGroupsApi.createGroup(group), (resp) => {
      if (resp.status === 'success') {
        libraryEvents.createdGroup(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Создание группы" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Вышестоящая группа">
          <LibraryGroupDropdown
            name="parentId"
            wrapperStyle={{ height: '32px' }}
            onChange={handleChange}
            value={group.parentId}
            title="Выберите группу"
          />
        </FormField>
        <FormField label="Наименование группы" required>
          <TextInput name="name" onChange={handleChange} value={group.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default CreateLibraryGroupModal
